import React from 'react';
import { Section } from '../ui/Section';
export function PartnerLogos() {
  return <Section background="white" className="py-12" data-id="element-116">
      <div className="text-center mb-8" data-id="element-117">
        <h2 className="text-2xl font-playfair font-bold text-primary-deep-blue" data-id="element-118">
          Our Partners
        </h2>
      </div>
      <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12" data-id="element-119">
        {[1, 2, 3, 4, 5].map(index => <div key={index} className="grayscale hover:grayscale-0 transition-all" data-id="element-120">
            {/* Placeholder for partner logos */}
            <div className="bg-neutral-offwhite h-16 w-32 rounded flex items-center justify-center" data-id="element-121">
              <span className="font-playfair text-primary-deep-blue opacity-70" data-id="element-122">
                Partner {index}
              </span>
            </div>
          </div>)}
      </div>
    </Section>;
}